<template>
	<div class="table">
		<el-table
			border
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }"
			style="width: 100%"
			height="60vh"
		>
			<el-table-column prop="id" label="ID" width="100"> </el-table-column>
			<el-table-column prop="nickname" label="用户名称"> </el-table-column>
			<el-table-column prop="email" label="联系方式"> </el-table-column>

			<el-table-column label="用户类型" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.userinfo">
						{{
							scope.row.type == 1
								? "普通用户"
								: scope.row.type == 3
								? "专栏用户"
								: "其他"
						}}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="身份转换" width="120">
				<template slot-scope="scope">
					<div v-if="scope.row.type == 1" @click="toChangeUserType(scope.row)">
						转换成专栏作者
					</div>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="200">
				<template slot-scope="scope">
					<span class="pointer" @click="toDetail(scope.row)"> 查看</span>
					<span class="pointer margin_left_10" @click="toEdit(scope.row)">
						编辑
					</span>
					<span class="pointer margin_left_10" @click="toDelete(scope.row)">
						删除
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { destroyusers, updateusers } from "@/api/user";

export default {
	props: ["tableData"],
	// watch: {
	//     "tableData":function(val,nval){
	//         this.newtableData=val
	//         this.rendertable=!this.rendertable
	//     }
	// },
	name: "",
	data() {
		return {
			value: true,
			// newtableData:[],
			// rendertable:true
		};
	},
	methods: {
		toDetail(row) {
			if (row.type == 1) {
				this.$router.push({
					path: "/addpersonal",
					query: { id: row.id, type: "detail" },
				});
			} else if (row.type == 3) {
				this.$router.push({
					path: "/addfirm",
					query: { id: row.id, type: "detail" },
				});
			}
		},
		toChangeUserType(row) {
			let that = this;
			row.userinfo.check_authentication = 2;
			let form = {};

			for (let key in row) {
				if (key === "userinfo") {
					for (let key2 in row.userinfo) {
						form[key2] = row.userinfo[key2];
					}
				} else {
					form[key] = row[key];
				}
			}
			form.auth_type = 2;
			form.type = 3;
			updateusers(form)
				.then((res) => {
					if (res.code == 200) {
						// that.$router.push({ path: "/user/userlist" });
						this.$message.success(
							"转换成功，审核中状态,请前往详情页完善信息并审核！"
						);
						+this.$parent.$parent.getDataList();
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		toEdit(row) {
			console.log(row.auth_type);
			if (row.type == 1) {
				this.$router.push({
					path: "/addpersonal",
					query: { id: row.id, type: "edit" },
				});
			} else if (row.type == 3) {
				this.$router.push({
					path: "/addfirm",
					query: { id: row.id, type: "edit" },
				});
			}
		},
		toDelete(row) {
			this.$confirm("此操作将删除该条用户, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					destroyusers({ types: 1, status: 0, id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
	},
};
</script>

<style scoped></style>
